/**
 * Button that looks like a link.
 */
import React from 'react';
import Button from '@atlaskit/button';

export default function LinkButton({children, ...props}) {
  return (<Button appearance="link" spacing="none" {...props}>{children}</Button>)
}
